import { styled } from '@uhg-abyss/web/tools/styled';

export const DefaultErrorWrapper = styled('div', {
  background: '#FAFCFF',
  height: '363px',
  '@media (max-width: 464px)': {
    height: '388px',
  },
});

export const BodyWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gridGap: '20px',
  marginRight: '1rem',
  '@media (max-width: 464px)': {
    marginRight: 0,
  },
});

export const textBody = {
  'abyss-text-root': {
    width: '55%',
    '@media (max-width: 984px)': {
      width: '100%',
    },
    a: {
      fontWeight: 'bold',
      textDecoration: 'underline',
    },
  },
};
